import axios from 'axios';
import { baseURL, config, requestID } from '../../common/utils';

const API_URL = 'YOUR_API_ENDPOINT';





export const getMyRequisitions = async () => {
  const data = {
    requestID: requestID(),
  }
  try {
    const response = await axios.post(`${baseURL}/requisitions/getEmployeeRequisitions`, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};





export const getRequisitionDetails = async (id) => {
  const data = {
    requestID: requestID(),
    requisition_id: id
  }
  try {
    const response = await axios.post(`${API_URL}/requisitions/employee`, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};



export const createRequisition = async (formData: FormData) => {


  try {
    const response = await axios.post(`${baseURL}requisitions/createRequisition`, formData, config)
    console.log({response})
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};

export const getManagerRequisitions = async () => {

  const data = {
    requestID: requestID()
  }

  try {
    const response = await axios.post(`${baseURL}requisitions/getManagerRequisitions`, data, config)
    console.log(response)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};
export const updateRequisitionStatus = async (payload) => {

  const data = {
    requestID: requestID(),...payload
  }

  try {
    const response = await axios.post(`${baseURL}requisitions/updateStatus`, data, config)
    console.log(response)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};